import React from 'react';
import PortfolioCard from '../components/PortfolioCard';
import { portfolioData } from '../data/portfolioData';

const Portfolio = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero" style={{
        background: `linear-gradient(rgba(13, 63, 105, 0.95), rgba(27, 164, 222, 0.85)), url('/images/mobileapp.png') no-repeat center center/cover`
      }}>
        <div className="container">
          <h1>Our Work</h1>
          <p>Discover how we've helped businesses transform their operations with cutting-edge mobile applications, web apps, and websites. As Nairobi's leading mobile app developers, we specialize in creating solutions that drive real results.</p>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="portfolio">
        <div className="container">
          <div className="section-title">
            <h2>Featured Projects</h2>
            <p>Explore our portfolio of successful digital solutions</p>
          </div>
          <div className="portfolio-grid">
            {portfolioData.map((project, index) => (
              <PortfolioCard
                key={project.id}
                project={project}
                delay={index * 100}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview">
        <div className="container">
          <div className="section-title">
            <h2>Our Development Expertise</h2>
            <p>As Kenya's leading mobile app developers, we deliver cutting-edge solutions across all platforms</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h3>Mobile App Development</h3>
              <p>We create native and cross-platform mobile applications for iOS and Android that deliver exceptional user experiences and drive business growth.</p>
              <ul>
                <li>Native iOS & Android Development</li>
                <li>Cross-Platform Solutions (React Native, Flutter)</li>
                <li>UI/UX Design & Prototyping</li>
                <li>App Store Deployment & Optimization</li>
              </ul>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-laptop-code"></i>
              </div>
              <h3>Web Application Development</h3>
              <p>We build scalable, secure, and dynamic web applications that streamline business operations and empower your team.</p>
              <ul>
                <li>Custom CRM & ERP Systems</li>
                <li>Progressive Web Apps (PWAs)</li>
                <li>E-commerce Platforms</li>
                <li>API Development & Integration</li>
              </ul>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>Website Development</h3>
              <p>We design and develop responsive, high-performance websites that make a powerful first impression and convert visitors into customers.</p>
              <ul>
                <li>Corporate & Business Websites</li>
                <li>E-commerce Solutions</li>
                <li>SEO Optimization</li>
                <li>Content Management Systems</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Have a Project in Mind?</h2>
          <p>Let's discuss how we can help bring your digital vision to life with our expertise in mobile app and web development.</p>
          <a href="/contact" className="btn">Get Started Today</a>
        </div>
      </section>
    </>
  );
};

export default Portfolio;